import React from "react";
import AvcilarSidebar from "../Sidebar/AvcilarSidebar";
import AvcilarOtherServices from "../ServiceAreas/AvcilarServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const AvcilarIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        AVCILAR HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Avcılar'da hijyenik, güvenli ve kaliteli halı-koltuk yıkama hizmeti almak isteyenler için
            en doğru adres burası! Tüm halı ve koltuklarınız özel sistemlerle, modern makinalar
            eşliğinde temizlenir ve mikrop, bakteri gibi zararlı oluşumlardan arındırılır.
          </p>

          <p>
            Avcılar Halı Yıkama hizmetimizde, leke tipine göre özel temizlik solüsyonları,
            koltuk türüne göre hassas fırçalama teknikleri uygulanır. Aynı zamanda buharlı ve
            şampuanlı sistemlerle koltuklarınız derinlemesine temizlenir.
          </p>

          <p>
            <strong>Avcılar Koltuk ve Halı Yıkama Hizmetinin Avantajları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Avcılar'ın tüm mahallelerinden ücretsiz alım ve teslimat</li>
            <li>Organik ve insan sağlığına zararsız temizlik ürünleri</li>
            <li>Kısa sürede teslimat garantisi (48 saat içinde)</li>
            <li>Evcil hayvan tüyü ve kokusu giderici işlemler</li>
            <li>Antibakteriyel buharla koltuk temizliği</li>
            <li>Yorgan, battaniye, perde gibi ek hizmetler</li>
          </ul>

          <p>
            Üniversite Mahallesi, Cihangir, Gümüşpala, Denizköşkler, Mustafa Kemal Paşa ve Merkez gibi
            mahallelerde hızlı ve yerinden servis imkânı sunmaktayız. Arayın, evinizden alalım,
            steril paketleme ile geri getirelim.
          </p>

          <p>
            Halılarınız türüne göre (el dokuma, shaggy, makine halısı) ayrılarak özel programlarda
            yıkanır. Koltuklar ise kumaş cinsine göre özel deterjanlar ve fırçalarla zarar
            verilmeden temizlenir.
          </p>

          <p>
            Sağlıklı yaşam alanları için Avcılar'da profesyonel temizlik hizmeti sunuyoruz.
            Uygun fiyat, kaliteli hizmet ve müşteri memnuniyetini bir arada arıyorsanız hemen bize ulaşın.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <AvcilarSidebar />
          <AvcilarOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default AvcilarIntro;
